export const ASSOCIATE_ROLES = ["associate", "senior", "maintenance"]
export const ASSOCIATE_MANAGER_ROLE = "associate manager"
export const MANAGER_ROLE = "manager"
export const DIRECTOR_ROLE = "director"
export const VP_ROLE = "vp"
export const MAINTENANCE_ROLE = "maintenance"
export const MAINTENANCE_MANAGER_ROLE = "maintenance manager"
export const ICC_SUPPORT_ROLE = "icc support"
